import React, { memo } from 'react';
import { Dropdown, Loader } from 'semantic-ui-react';

/**
 * ActorSelector component
 * Dropdown selector for choosing voice actors
 * @param {Object} props - Component props
 * @param {Array} props.actors - Array of actor objects
 * @param {string} props.selectedActorId - Currently selected actor ID
 * @param {Function} props.onActorSelect - Callback when an actor is selected
 * @param {boolean} props.loading - Whether actors are loading
 * @returns {JSX.Element} ActorSelector component
 */
const ActorSelector = memo(({
  actors = [],
  selectedActorId,
  onActorSelect,
  loading = false
}) => {
  console.log('[ACTOR_SELECTOR] Rendering with:', {
    actorCount: actors.length,
    selectedActorId,
    loading
  });

  // Create dropdown options from actors
  const actorOptions = actors.map(actor => ({
    key: actor.uuid,
    text: `${actor.firstName} ${actor.lastName}`,
    value: actor.uuid
  }));

  return (
    <div style={{ marginBottom: '1em' }}>
      <div style={{
        marginTop: '0.6em',
        position: 'relative'
      }}>
        <label style={{ display: 'block', marginBottom: '0.5em', fontWeight: 'bold' }}>
          Select Voice Actor
        </label>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '10px' }}>
            <Loader active inline size="small" />
            <span style={{ marginLeft: '10px' }}>Loading actors...</span>
          </div>
        ) : (
          <Dropdown
            selection
            options={actorOptions}
            value={selectedActorId || ''}
            onChange={(e, { value }) => {
              console.log('[ACTOR_SELECTOR] Actor selected:', value);
              onActorSelect(value);
            }}
            placeholder="Select Voice Actor"
            fluid
            style={{ zIndex: 1000 }}
            disabled={actors.length === 0}
            noResultsMessage={actors.length === 0 ? "No actors available" : "No matching actors"}
          />
        )}

        {!loading && actors.length === 0 && (
          <div style={{
            fontSize: '0.9em',
            color: '#888',
            marginTop: '5px',
            fontStyle: 'italic'
          }}>
            No voice actors found. Please create an actor first.
          </div>
        )}
      </div>
    </div>
  );
});

ActorSelector.displayName = 'ActorSelector';

export default ActorSelector;
